import React, { useState, useEffect } from "react";
import { Input, Table, Tag, theme, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { colors } from "./../../devdata/constants/themes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown,
  faStar,
  faSearch,
  faArrowsRotate,
  faAlignRight,
} from "@fortawesome/free-solid-svg-icons";
import { Statescontex, useUserContext } from "../../context";
import { Demohai, Livehai, Algotester } from "..";
import { Subhai } from "..";
import { whaticonstocks } from "../../devdata/maps/whaticon";
import { stocks as lolstocks } from "../../devdata/maps/chartred";
import { Button, Tooltip } from "antd";
import PiScoreTag from "../piScoreTag";
import PiStatusBadge from "../piStatusBadgeWithTrend";
import PiStatusBadgeWithTrend from "../piStatusBadgeWithTrend";
const DhanIcon = require("../../devdata/icons/dhanLogo.png");
const AlgoIcon = require("../../devdata/icons/algoTestLogo.jpg");
const Topperformer = ({ title, description, top }) => {
  const { setdaystocks, daystocks, isDhanLogged, dhanToken, userdetails } = useUserContext();
  const { live } = Statescontex();
  const [favorites, setFavorites] = useState(new Set());
  const [loading, setLoading] = useState(false);
  const [priceSortOrder, setPriceSortOrder] = useState<"descend" | "ascend">(
    "descend"
  );
  const [changeSortOrder, setChangeSortOrder] = useState<"descend" | "ascend">(
    "descend"
  );
  const [searchValue, setSearchValue] = useState("");
  const [stocks, setStocks] = useState([]);
  const [searchVisible, setSearchVisible] = useState(false);
  const [filteredStocks, setFilteredStocks] = useState(stocks);
  const [refresh, setrefresh] = useState(false);
  const [sectors, setSectors] = useState([]);
  const [selectedSector, setSelectedSector] = useState("All Sectors");
  const [recordit, setrecordit] = useState()

  const handleCloseSearch = () => {
    if (!searchValue) {
      setSearchVisible(false);
      handleSearch("");
    }
  };
  // --- Filtering and Sorting Logic ---
  const applyFilters = (sourceData, sector, showGood, search, sortOrder) => {
    let intermediateData = [...sourceData];

    if (sector !== "All Sectors") {
      intermediateData = intermediateData.filter(
        (stock) => stock.sector === sector
      );
    }
    if (search) {
      intermediateData = intermediateData.filter((stock) =>
        stock.name.toLowerCase().startsWith(search.toLowerCase())
      );
    }
    if (sortOrder) {
      // Apply final sort order
      sortData(intermediateData, "per_chg", sortOrder);
    }
    setFilteredStocks(intermediateData);
  };

  const sortData = (dataToSort, key, direction) => {
    const sorted = [...dataToSort].sort((a, b) => {
      const aValue = a[key];
      const bValue = b[key];
      // Handle potential non-numeric values during sort
      const numA = typeof aValue === "number" ? aValue : -Infinity;
      const numB = typeof bValue === "number" ? bValue : -Infinity;
      return direction === "ascend" ? numA - numB : numB - numA;
    });
    setFilteredStocks(sorted);
  };

  useEffect(() => {
    applyFilters(stocks, selectedSector, false, searchValue, changeSortOrder);
  }, [stocks, selectedSector, searchValue, changeSortOrder]);

  const handleSectorChange = (value) => {
    setSelectedSector(value);
    applyFilters(stocks, value, false, searchValue, changeSortOrder);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    applyFilters(stocks, selectedSector, false, value, changeSortOrder);
  };

  const toggleFavorite = (key, event) => {
    event.stopPropagation();

    setFavorites((prev) => {
      const updated = new Set(prev);
      if (updated.has(key)) {
        updated.delete(key);
      } else {
        updated.add(key);
      }
      return updated;
    });
    setdaystocks((prev) => {
      if (prev.includes(key)) {
        return prev.filter((stock) => stock !== key);
      } else {
        return [...prev, key];
      }
    });
  };
  const handleAlgotestClick = (record) => {
    // console.log(record);

    setrecordit(record)
  };
  const fetchitup = () => {
    try {
      let d = sessionStorage.getItem("all");
      if (d) {
        let parseddata = JSON.parse(d);

        if (top) {
          //sort the stock by per_chg in descending order
          parseddata = parseddata.sort((a, b) => b.per_chg - a.per_chg);
        } else {
          //sort the stock by per_chg in ascending order
          parseddata = parseddata.sort((a, b) => a.per_chg - b.per_chg);
        }

        setStocks(parseddata);
        //   console all unique sectors
        const uniqueSectors = new Set();
        parseddata.forEach((stock) => uniqueSectors.add(stock.sector));
        setSectors(Array.from(uniqueSectors));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchitup();
    const interval = setInterval(() => {
      fetchitup();
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const columns = [
    {
      title: "",
      dataIndex: "nsecode",
      key: "favorite",
      width: "5%",
      align: "center",
      render: (key) => (
        <div
          className="p-2 cursor-pointer flex items-center justify-center"
          onClick={(e) => toggleFavorite(key, e)}
        >
          <FontAwesomeIcon
            icon={faStar}
            className={`text-base transition-colors duration-200 ${daystocks.includes(key)
              ? "text-yellow-500"
              : "text-darkMode-layer3 hover:text-yellow-300"
              }`}
          />
        </div>
      ),
    },
    {
      title: "Stock",
      dataIndex: "name",
      key: "name",
      align: "left",
      width: "40%",
      render: (text, record) => (
        <div className="flex items-center gap-2">
          {whaticonstocks[record.name] ? (
            <img
              src={whaticonstocks[record.name]}
              alt={`${text} icon`}
              className="w-7 h-7 rounded-full object-cover flex-shrink-0"
            />
          ) : (
            <div className="w-7 h-7 bg-darkMode-layer3 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white text-sm">?</span>
            </div>
          )}
          <span
            className="text-xs sm:text-sm line-clamp-2 cursor-pointer"
            onClick={() => {
              const found = lolstocks.find(
                (stock) => stock.nsecode === record.nsecode
              );
              const foundUrl = isDhanLogged
                ? found?.dhanUrl?.replace("123GOFREE", dhanToken)
                : found?.url || found?.url;
              if (foundUrl) {
                window.open(foundUrl, "_blank");
              } else {
                console.error("URL not found");
              }
            }}
          >
            {text}
          </span>
        </div>
      ),
    },
    {
      title: "Sector",
      dataIndex: "sector",
      key: "sector",
      align: "center",
      width: "12%", // Adjusted width
      ellipsis: true,
      render: (text) => (
        <span className="text-xs sm:text-sm px-1">{text || "-"}</span>
      ),
    },
    {
      title: (
        <div className="flex items-center justify-center whitespace-nowrap">
          <span>% Change</span>
        </div>
      ),
      dataIndex: "per_chg",
      key: "per_chg",
      width: "15%",
      align: "center",
      render: (text) => (
        <Tag
          className={`rounded-full bg-opacity-20 border-none text-xs font-semibold py-0.5 px-1.5 ${text > 0
            ? "bg-darkMode-green text-darkMode-green"
            : text < 0
              ? "bg-darkMode-red text-darkMode-red"
              : "bg-gray-500 text-gray-300"
            }`}
        >
          {typeof text === "number" ? `${text.toFixed(2)}%` : "0%"}
        </Tag>
      ),
    },
    {
      title: (
        <div className="flex items-center justify-center whitespace-nowrap">
          <span>Pi Score</span>
        </div>
      ),
      dataIndex: "pil",
      key: "pil",
      width: "12%",
      align: "center",
      render: (text) => <PiScoreTag value={text} />,
    },
    {
      title: <span className="text-xs sm:text-sm">Suggestion</span>,
      dataIndex: "pistatus",
      key: "good",
      align: "center",
      width: "16%", // Adjusted width, needs enough space for the tag

      render: (_: any, row: any) => (
        <PiStatusBadgeWithTrend
          pistatus={row.pistatus}
          trendBadge={row.trendBadge}
        />
      ),
    },
    {
      title: <span className="text-xs sm:text-sm">Automate</span>,
      key: "actions",
      align: "center",
      width: "13%", // Adjusted width, needs enough space for the tag
      render: (record) => {
        return (
          <div className="flex items-center justify-center px-1">
            <Button shape="circle" size="small" onClick={() => handleAlgotestClick(record)}>
              <img src={AlgoIcon} alt="Algo Test" className="w-auto h-full" />
            </Button>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    setrefresh(true);
  }, []);

  return (
    <div
      className="p-4 relative rounded-xl bg-darkMode-layer1 shadow-lg"
      style={{ minHeight: 400 }}
    >
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-2 items-center">
          <div>
            <h2 className="text-xl font-semibold text-darkMode-text">
              {title}
            </h2>
            <p className="text-sm text-darkMode-subText">{description}</p>
          </div>
          {/* <Livehai /> */}
        </div>
        <div>
          <Demohai what={undefined} />
        </div>
      </div>
      <div className="flex gap-2 items-center justify-between mb-6">
        <div className="text-darkMode-text w-auto max-w-[180px] sm:max-w-[200px] flex-grow-0">
          <Select
            defaultValue="All Sectors"
            value={selectedSector}
            style={{
              width: "100%",
              minWidth: "100px",
              textAlign: "center",
              height: 40,
            }}
            onChange={handleSectorChange}
            options={[
              {
                label: "All Sectors",
                value: "All Sectors",
              },
              ...sectors.map((sector) => ({
                label: sector,
                value: sector,
              })),
            ]}
          />
        </div>
        <div className="flex justify-between items-center">
          <div className="flex gap-2 items-center text-white">
            {searchVisible ? (
              <Input
                className="h-[40px] text-sm px-3 py-2 rounded-lg bg-darkMode-layer2 shadow-md transition-all duration-300 ease-in-out border-none hover:ring-1 hover:ring-darkMode-green cursor-pointer max-w-[250px]"
                placeholder="Search"
                prefix={<SearchOutlined />}
                value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
                allowClear
                autoFocus
                onBlur={handleCloseSearch}
                onPressEnter={handleCloseSearch}
              />
            ) : (
              <div
                className="bg-darkMode-layer2 flex items-center justify-center h-[40px] text-sm px-3 py-2 rounded-lg shadow-md transition-all duration-300 ease-in-out hover:ring-1 hover:ring-darkMode-green cursor-pointer"
                onClick={() => setSearchVisible(true)}
              >
                <FontAwesomeIcon icon={faSearch} className="mr-1" />
                Search
              </div>
            )}
            <button
              onClick={() => {
                setrefresh(!refresh);
              }}
              className="flex items-center justify-center w-[40px] h-[40px] text-xs sm:text-sm px-3 py-2 rounded-lg bg-darkMode-layer2 shadow-sm transition-all duration-300 ease-in-out hover:ring-1 hover:ring-darkMode-green text-darkMode-subText hover:text-darkMode-text"
            >
              <FontAwesomeIcon icon={faArrowsRotate} />
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="relative">
        <Subhai />

        <Table
          dataSource={filteredStocks}
          columns={columns}
          pagination={{
            defaultPageSize: 5,
          }}
          rowKey="nsecode"
          className="rounded-lg overflow-hidden shadow-sm text-darkMode-text"
          rowClassName="cursor-default"
          scroll={{ x: "max-content" }}
          onRow={(record, rowIndex) => {
            return {};
          }}
        />
      </div>
      <Algotester userdetails={userdetails} recordit={recordit} />
    </div>
  );
};

export default Topperformer;
